// Import React core library
import React from 'react';

// Import ReactDOM for rendering React components to the DOM
import ReactDOM from 'react-dom/client';

// Import BrowserRouter from react-router-dom for enabling client-side routing
import { BrowserRouter } from 'react-router-dom'; // Wrap your app to use <Route> and <Link>

// Import the main App component which contains the entire application
import App from './App'; 

// Import the global CSS including Tailwind styles
import "./index.css";

// Create a root element for React to attach the app to the DOM
const root = ReactDOM.createRoot(document.getElementById('root')); // 'root' is the div in public/index.html

// Render the React app into the root element
root.render(
  <React.StrictMode> {/* StrictMode helps detect potential problems in development */}
    <BrowserRouter>   {/* Enables routing functionality for the App */}
      <App />          {/* Render the main App component */}
    </BrowserRouter>
  </React.StrictMode>
);
